module.exports = __webpack_public_path__ + "static/img/btn5.6e1c7d94.png";